import styled from 'styled-components'

export const Container = styled.div`
    padding: 20px;
    position: relative;
    /* max-width: 1440px; */

    h1 {
        margin-top: 10px;
        color: #333;
        font-family: 'Inter';
        font-weight: 500;
    }

    .cards {
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 100%;
        @media (min-width: 550px) {
            flex-direction: row;
            align-items: center;
            height: 200px;
        }
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0;
    }
`

export const SearchAgenda = styled.div`
    /* margin-top: 50px;
    margin-bottom: 50px; */
    display: flex;
    flex-direction: column;
    gap: 14px;
    @media (min-width: 720px) {
        gap: 30px;
    }

    .top-bar {
        display: flex;
        flex-direction: column;
        gap: 14px;

        h1 {
            font-size: 20px;
            color: #333;
            font-family: 'Inter';
            font-weight: 500;
        }

        .right-side {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        }

        @media (min-width: 720px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 0px;

            .right-side {
                flex-direction: row;
                align-items: center;
                justify-content: initial;
            }
        }
        @media (max-width: 350px) {
            .payment-button {
                display: none;
            }
        }
    }

    .bottom-bar {
        display: flex;
        flex-direction: column-reverse;
        gap: 14px;

        /* .right-side {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        } */
        .right-side {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            position: relative;
            .css-ek1bv6-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
            }
            .MuiInputBase-root.MuiOutlinedInput-root {
                border-radius: 0.5rem;
            }
            .Mui-focused {
                background: red;
            }
            .agenda {
                background: #fff;
                position: absolute;
                top: calc(40px + 10px);
                right: 0;
                /* width: 150px; */
                z-index: 2;

                border-radius: 6px;
                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
                ul {
                    display: flex;
                    flex-direction: column;
                }

                button {
                    color: #333;
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    border-bottom: 1px solid #d3d3d3;
                    width: 100%;

                    &:not(:disabled):hover {
                        background: rgba(37, 99, 235, 0.03);
                        background: rgba(0, 157, 221, 0.1);
                    }

                    svg {
                        color: red;
                    }
                }
            }
        }

        @media (min-width: 720px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 0px;

            .right-side {
                justify-content: initial;
                .react-datepicker-wrapper {
                    width: auto;
                }
            }
        }
    }
    /* > form {
        display: flex;
        flex-direction: column;
        gap: 14px;
        @media (min-width: 768px) {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
        }

        .input-group {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .actions {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            button + button {
                margin-left: 30px;
            }
        }

        span {
            font-family: 'Roboto';
            font-size: 12px;
            color: #eb214e;
        }
    } */
`

export const CustomPayment = styled.div`
    background: #fff;
    padding: 15px 10px 15px 10px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    border-radius: 10px;

    h2 {
        font-family: 'Roboto';
        font-size: 21px;
        font-weight: 400;
        margin-bottom: 20px;
    }

    form {
        display: flex;
        flex-direction: column;
        gap: 18px;

        .input-group {
            display: flex;
            flex-direction: column;
            gap: 10px;

            @media (min-width: 500px) {
                flex-direction: row;
                align-items: center;
                gap: 10px;
                margin-right: 30px;
            }
        }

        .input-wrapper {
            display: flex;
            align-items: center;
            font-family: 'Roboto';
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.4375em;

            label {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-right: 5px;
                color: rgba(0, 0, 0, 0.6);
            }

            input {
                height: 40px;
                padding: 6px 8px;
                border: 1px solid #d3d3d3;
                border-radius: 6px;
                font-size: 17px;
                color: #333;
                cursor: pointer;
            }

            .date {
                height: 40px;
                padding: 6px 8px;
                border: 1px solid #d3d3d3;
                border-radius: 6px;
                font-size: 17px;
                color: #333;
                cursor: pointer;
            }

            .MuiTextField-root {
                .MuiOutlinedInput-root {
                    /* height: 40px; */
                }
            }
        }

        @media (min-width: 1024px) {
            flex-direction: row;
            gap: 0px;
        }
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        margin-top: 18px;
    }
`

export const Content = styled.div``

export const UnidadeRecebivel = styled.div`
    /* border-bottom: 1px solid #D3D3D3; */
    /* border-top: 1px solid #D3D3D3; */
    padding: 20px 15px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    border-radius: 10px;
    width: 100%;
    height: 100%;

    h2 {
        /* text-align: center; */
        font-family: 'Roboto';
        font-weight: 500;
        margin-bottom: 10px;
    }

    span {
        font-family: 'Inter';
        font-weight: 500;
    }
`

export const Schedule = styled.div`
    padding: 20px 15px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    border-radius: 10px;
    height: 100%;
    width: 100%;
    /* border-bottom: 1px solid #D3D3D3; */

    @media (min-width: 550px) {
        width: 50%;
    }
    h2 {
        /* text-align: center; */
        font-family: 'Roboto';
        font-weight: 500;
        margin-bottom: 10px;
    }
    span {
        font-family: 'Inter';
        font-weight: 500;
    }
`

export const ContainerUR = styled.div`
    margin-top: 30px;
    border-radius: 10px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    overflow: auto;
`

export const Pagamentos = styled.div`
    margin-top: 30px;
    border-radius: 10px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    margin-bottom: 80px;
    overflow: auto;
`

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 10px;

    /* border-bottom: 1px solid #D3D3D3; */
    gap: 15px;
    @media (min-width: 1380px) {
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        gap: 40px;
    }

    form {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        gap: 10px;

        @media (min-width: 870px) {
            flex-direction: row;
            align-items: center;
            /* margin-left: 40px; */
            gap: 0;
        }

        .input-group {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-right: 30px;
        }

        .input-wrapper {
            display: flex;
            align-items: center;
            font-family: 'Roboto';
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.4375em;

            label {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-right: 5px;
                color: rgba(0, 0, 0, 0.6);
            }

            input {
                height: 30px;
                padding: 6px 8px;
                border: 1px solid #d3d3d3;
                border-radius: 6px;
                font-size: 17px;
                color: #333;
                cursor: pointer;
            }

            .date {
                height: 40px;
                padding: 6px 8px;
                border: 1px solid #d3d3d3;
                border-radius: 6px;
                font-size: 17px;
                color: #333;
                cursor: pointer;
            }
            .MuiTextField-root {
                .MuiOutlinedInput-root {
                    height: 40px;
                }
            }
        }

        .slider {
            width: 250px;
        }

        button {
            margin-left: auto;
        }
    }
    .title {
        display: flex;
        align-items: center;
        gap: 2px;
        h2 {
            /* width: fit-content; */
            white-space: nowrap;
            font-family: 'Roboto';
            font-size: 20px;
            font-weight: 500;
            margin-right: 5px;
        }
        span.count {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 25px;
            height: 20px;
            background: rgba(90, 219, 148, 0.3);
            color: #3fd97f;
            font-family: 'Roboto';
            font-weight: 500;
            font-size: 12px;
            border-radius: 6px;
        }
    }
`

export const TableUR = styled.table`
    padding: 10px;
    table-layout: fixed;
    /* border: 1px solid #333; */
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        border-top: 1px solid #d3d3d3;

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
        }

        th:first-child {
            width: 50px;
            padding: 0 10px 0px 14px;
        }

        th:last-child {
            width: 10%;
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 14px;

            img {
                height: 45px;
                width: 70px;
            }
        }

        td:first-child {
            width: 50px;
            padding: 0 10px 0px 14px;
        }
        tr {
            position: relative;
            cursor: pointer;

            &:hover {
                background: rgba(37, 99, 235, 0.03);
            }
        }

        tr.marked {
            background: rgba(0, 157, 221, 0.05);
            background: rgba(37, 99, 235, 0.03);
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }

    .order {
        display: flex;
        align-items: center;
        gap: 3px;
        transform: rotate(0deg);
        transition: transform 0.2s ease-in;
        cursor: pointer;
    }

    .order.desc {
        svg {
            transform: rotate(180deg);
        }
    }

    .checkbox {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .selected {
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 4px;
            height: 100%;
            background-color: rgb(37, 99, 235);
            border-radius: 0px 10px 10px 0;
        }
    }

    td.edit {
        width: 10%;
        > span {
            white-space: nowrap;
            padding: 3px 5px;
            border: 1px solid #d3d3d3;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            &:hover {
                color: #566583;
            }
        }
    }
`

export const Table = styled.table`
    padding: 10px;
    table-layout: fixed;
    /* border: 1px solid #333; */
    border-collapse: collapse;
    width: 100%;
    min-width: 600px;

    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        border-top: 1px solid #d3d3d3;

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
        }

        th:first-child {
            width: 50px;
            padding: 0 10px;
        }

        th:last-child {
            width: 10%;
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 14px;
        }

        td:first-child {
            width: 50px;
            padding: 0 10px;
        }

        td.button {
            width: 10%;
            > span {
                /* background: red; */
                white-space: nowrap;
                padding: 3px 5px;
                border: 1px solid #d3d3d3;
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                cursor: pointer;
                &:hover {
                    color: #566583;
                }
            }
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }

    .checkbox {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }
`
